import Plyr from 'plyr'

import { qsa } from '../utils'
class TimeSingle {
  constructor() {
    this.namespace = 'time-single'
  }

  afterEnter({ next }) {
    this.videos = qsa('[data-player]', next.container)
    this.videos.map(video => new Plyr(video))
  }
}

export default new TimeSingle()
